import UpArrow from '@ds/icons/assets/DsIcon-ArrowUp.svg';
import DownArrow from '@ds/icons/assets/DsIcon-ArrowDown.svg';
import RightArrow from '@ds/icons/assets/DsIcon-ArrowRight.svg';

export const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/ug, '$1.');
};

export const colorVariation = (variation) => {
  if (variation === 0) return 'var(--ds-color-text-2)';

  if (variation > 0) return '#18BF29';

  return '#FF1300';
};

export const iconVariation = (variation) => {
  if (variation === 0) return RightArrow;

  if (variation > 0) return UpArrow;

  return DownArrow;
};
